import {lazy} from 'react';
import {Navigate, Route} from 'react-router-dom';
import ClientPortalRoute from './guards/ClientPortalRoute.tsx';

const ClientPortalLayout = lazy(() => import('./layouts/ClientPortalLayout.tsx'));
const Dashboard = lazy(() => import('./pages/Dashboard.tsx'));
const EmpleadosList = lazy(() => import('./pages/EmpleadosList.tsx'));
const EmpleadoExpedienteDetalle = lazy(() => import('./components/EmpleadoExpedienteDetalle.tsx'));
const CentroNotificacionesPortal = lazy(() => import('./pages/CentroNotificacionesPortal.tsx'));
const CertificadosList = lazy(() => import('./pages/CertificadosList.tsx'));
const AgendaPortal = lazy(() => import('./pages/AgendaPortal.tsx'));
const PerfilPortal = lazy(() => import('./pages/PerfilPortal.tsx'));

export const CLIENT_PORTAL_PATHS = {
    dashboard: '/portal-cliente/dashboard',
    empleados: '/portal-cliente/empleados',
    certificados: '/portal-cliente/certificados',
    agenda: '/portal-cliente/agenda',
    notificaciones: '/portal-cliente/notificaciones',
    perfil: '/portal-cliente/perfil',
    empleadoExpediente: id => `/portal-cliente/empleados/${id}/expediente`
};

export const isClientPortalPath = pathname => pathname.startsWith('/portal-cliente');

export const ClientPortalRoutes = (
    <>
        <Route
            path="/portal-cliente"
            element={
                <ClientPortalRoute>
                    <ClientPortalLayout />
                </ClientPortalRoute>
            }
        >
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="empleados" element={<EmpleadosList />} />
            <Route path="empleados/:id/expediente" element={<EmpleadoExpedienteDetalle />} />
            <Route path="certificados" element={<CertificadosList />} />
            <Route path="agenda" element={<AgendaPortal />} />
            <Route path="notificaciones" element={<CentroNotificacionesPortal />} />
            <Route path="perfil" element={<PerfilPortal />} />
            <Route path="empleados/carga-masiva" element={<Navigate to="/portal-cliente/empleados" replace />} />
        </Route>
    </>
);
